/**
 * House of Places — plain quick-buy.
 *
 * The [data-hop-quickbuy] button is a real add-to-cart submit, so with no JS
 * it still works as a normal form submission. With JS, the same click sends
 * the chosen variant straight to checkout through a cart permalink — the
 * unbranded fast path the merchant asked for instead of the wallet button
 * ("Buy with shop"). With personalisation filled in it adds to the cart and
 * opens /checkout instead (see below).
 */
(function () {
  // Dawn's quick-add modal re-runs every script inside <product-info> each
  // time it opens; bind once per page so no listener fires twice.
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-quickbuy']) return;
  yuklu['hop-quickbuy'] = true;

  document.addEventListener('click', function (e) {
    var buton = e.target.closest('[data-hop-quickbuy]');
    if (!buton || buton.disabled) return;

    var form = buton.closest('form');
    if (!form) return; // let the browser do whatever it was going to do

    e.preventDefault();
    buton.setAttribute('aria-disabled', 'true');
    buton.classList.add('loading');
    var donen = buton.querySelector('.loading__spinner');
    if (donen) donen.classList.remove('hidden');

    var veri = new FormData(form);
    var varyant = veri.get('id');
    var adet = parseInt(veri.get('quantity'), 10) || 1;
    // Only a line-item property the shopper actually filled in counts
    // (personalisation text); empty fields are just the unused form.
    var ozellikVar = false;
    veri.forEach(function (deger, ad) {
      if (ad.indexOf('properties[') === 0 && String(deger).trim() !== '') ozellikVar = true;
    });
    // A subscription plan cannot ride on a permalink either.
    if (veri.get('selling_plan')) ozellikVar = true;

    // "Buy it now" means THIS product only. Adding to the cart and opening
    // /checkout took everything else in the cart along (and left this item
    // behind in it). A cart permalink checks out just this variant and leaves
    // the cart alone — the same thing Dawn's dynamic button did.
    if (varyant && !ozellikVar) {
      window.location.href = '/cart/' + encodeURIComponent(varyant) + ':' + adet;
      return;
    }

    // A permalink cannot carry line-item properties, so a personalised
    // poster still goes through the cart: add it, then check out. Anything
    // already in the cart travels with it — accepted, because dropping the
    // personalisation would be worse.
    fetch('/cart/add.js', { method: 'POST', body: veri })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        // Fall back to the normal add-to-cart path so the click never dies.
        buton.classList.remove('loading');
        buton.removeAttribute('aria-disabled');
        if (donen) donen.classList.add('hidden');
        form.requestSubmit();
      });
  });
})();
